import { Box, Checkbox, CheckboxProps } from '@chakra-ui/react';
import { ChangeEvent, FunctionComponent } from 'react';
// eslint-disable-next-line import/no-cycle
import { ColorSchemes } from '../../../ChakraTheme';
import { CFormError } from '../../../Typography';
import { CSingleCheckboxProps } from './Checkbox.types';

export const CCheckbox: FunctionComponent<CheckboxProps> = ({ ...props }) => {
    return <Checkbox {...props} colorScheme={ColorSchemes.primary} />;
};

export const CSingleCheckbox = ({
    onChange,
    testId,
    label,
    showError = false,
    errorText,
    checked,
    ...props
}: CSingleCheckboxProps): JSX.Element => {
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.checked);
    };

    return (
        <Box height={props?.height} width={props?.width}>
            <CCheckbox
                {...props}
                isChecked={checked}
                onChange={handleChange}
                data-test={`${testId}--single`}
            >
                {label}
            </CCheckbox>
            {showError && (
                <CFormError data-test={`${testId}--error`} text={errorText} />
            )}
        </Box>
    );
};
